const updateFunc = (controlData) => {
  const specificity =
    controlData["specificity"] !== undefined ? controlData["specificity"] : 95;

  const fp = 100 - specificity;
  const tn = specificity;

  const calculatedData = {};
  calculatedData.fp = fp;
  calculatedData.tn = tn;
  return calculatedData;
};

export default updateFunc;
